export const PRIMARY_FRAMEWORKS_LIMIT = 1;
export const SECONDARY_FRAMEWORKS_LIMIT = 3;
export const FRAMEWORKS_SUGGESTIONS_LIMIT = 10;
export const FRAMEWORKS_SUGGESTIONS_COLLAPSED_LIMIT = 5;
